import React from "react";
import { TrendingDown, DollarSign, Shield, TrendingUp, Users, Award } from "lucide-react";
import { Card, CardContent } from "./ui/card";

const Services = () => {
  const services = [
    {
      icon: <TrendingDown className="service-icon" />,
      title: "Low margin approach",
      description: "We operate on lower margins than traditional recruiters, ensuring you receive a larger portion of the client's budget as your compensation."
    },
    {
      icon: <DollarSign className="service-icon" />,
      title: "Market-rate guidance",
      description: "We ensure you're paid what you're worth—above market rates based on our expertise from successfully placing similar professionals."
    },
    {
      icon: <Shield className="service-icon" />,
      title: "Security clearance pathways",
      description: "We can refer you to an authorized DISP‑accredited partners who are able to sponsor eligible candidates for security clearances required in state/federal government roles that demand specialized expertise."
    },
    {
      icon: <TrendingUp className="service-icon" />,
      title: "Career acceleration programs", 
      description: "Strategic placement in roles that build your expertise while advancing your career trajectory in high-growth sectors."
    },
    {
      icon: <Users className="service-icon" />,
      title: "Exclusive client network",
      description: "Access to select opportunities with government departments, financial institutions, and enterprise clients through our established partnerships."
    },
    {
      icon: <Award className="service-icon" />,
      title: "Long-term partnership",
      description: "We're invested in your career success, not just the next placement. Ongoing support and future opportunities."
    }
  ];

  return (
    <section id="services" className="section-padding bg-light">
      <div className="container">
        <div className="services-header">
          <h2 className="section-heading centered">What sets us apart from other recruiters</h2>
          <p className="section-subtext centered">
            While others compete on volume, we compete on value—for both our clients and candidates
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <Card key={index} className="service-card">
              <CardContent className="service-content">
                <div className="service-icon-wrapper">
                  {service.icon}
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
